import { GridItemType } from "components/Chakra/Card/CardMotion";
import CardVariant from "components/Chakra/Card/CardVariant";

export const firstTabItems: Array<GridItemType> = [
  {
    content: (
      <CardVariant
        type="GREY_LIGHT"
        title="Pečujeme o více než 3 500 + nemovitostí"
        subTitle="Služba Ideální nájemce"
        href="https://idealninajemce.cz/"
        image={{
          src: "/img/scenes/NewHomepage/guy-sofa.webp",
          style: {
            position: "relative",
            bottom: "-20px",
            left: "-40px",
            objectFit: "cover",
            marginTop: "auto",
          },
        }}
        trackingElab="Ideální nájemce"
      />
    ),
    gridItemSetting: { name: "A", h: { base: "360px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        type="ORANGE"
        title="Inzerce s jedničkou na trhu"
        subTitle="Soukromá inzerce"
        to="/vyhody/soukroma-inzerce"
        trackingElab="Soukromá inzerce"
      />
    ),
    gridItemSetting: { name: "B", h: { base: "200px", md: "240px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_WHITE"
        title="Vzor nájemní smlouvy, výpovědi i protokolu"
        subTitle="Vzory smluv"
        bgImage={{ scr: "/img/scenes/NewHomepage/woman-table.webp" }}
        href="https://idealninajemce.cz/pronajimam/vzory-smluv"
        trackingElab="Vzory smluv"
      />
    ),
    gridItemSetting: { name: "C", h: { base: "200px", md: "240px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_DARK_GRAY"
        title="Správa pronájmu ve vlastních rukou"
        subTitle="Aplikace Houmy"
        bgImage={{
          scr: "/img/scenes/NewHomepage/product-tile-houmy.png",
          filter: "none",
        }}
        href="https://www.houmy.cz/"
        trackingElab="Aplikace Houmy Majitelé"
      />
    ),
    gridItemSetting: { name: "D", h: { base: "360px", md: "500px" } },
  },
  {
    content: (
      <CardVariant
        title="Průvodce světem realit"
        subTitle="Realitní blog"
        type="IMAGE_BACKGROUND_WHITE"
        bgImage={{ scr: "/img/scenes/NewHomepage/notebook-bed.webp" }}
        to="/radce/majitel"
        trackingElab="Realitní blog_soukromý majitel"
      />
    ),
    gridItemSetting: { name: "E", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        type="GREY_DARK"
        title="Kompletní prověření v 16 CZ i SK rejstřících"
        subTitle="Prověření rizikovosti osob"
        image={{
          src: "/img/scenes/NewHomepage/reportProvereneOsoby.webp",
          style: {
            position: "relative",
            bottom: "-40px",
            objectFit: "cover",
            marginTop: "auto",
            maxWidth: "80%",
          },
        }}
        to="/provereni-rizikovosti-osob"
        trackingElab="CC_soukromý majitel"
      />
    ),
    gridItemSetting: { name: "F", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        type="ORANGE"
        title="Prodej nemovitosti po celé ČR"
        subTitle="Osobní makléř"
        to="/prodeje-nemovitosti"
        trackingElab="Prodej nemovitosti"
      />
    ),
    gridItemSetting: { name: "G", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        type="GREY_DARK"
        title="Inzerát v nejlepším světle"
        subTitle="Virtuální prezentace"
        to="/vizualni-prezentace"
        trackingElab="Vizuální prezentace_soukromý majitel"
      />
    ),
    gridItemSetting: { name: "H", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        title="Obsazení bez starostí"
        subTitle="Osobní makléř"
        type="GREY_LIGHT"
        href="https://idealninajemce.cz/pronajimam/obsazeni-bez-starosti"
        trackingElab="Pronájem nemovitosti"
      />
    ),
    gridItemSetting: { name: "CH", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        title="Online odhad nájemného"
        subTitle="Nacenění nemovitosti"
        type="IMAGE_BACKGROUND_WHITE"
        bgImage={{ scr: "/img/scenes/NewHomepage/table-calc.webp" }}
        href="https://idealninajemce.cz/pronajimam/naceneni-najmu"
        trackingElab="Nacenění nemovitosti"
      />
    ),
    gridItemSetting: { name: "I", h: { base: "200px", md: "100%" } },
  },
  {
    content: (
      <CardVariant
        title="Vývoj cen ve městech"
        subTitle="Cenové mapy"
        type="IMAGE_BACKGROUND_WHITE"
        bgImage={{ scr: "/img/scenes/NewHomepage/building.webp" }}
        href="https://idealninajemce.cz/cenova-mapa-najemneho"
        trackingElab="Cenové mapy"
      />
    ),
    gridItemSetting: { name: "J", h: { base: "200px", md: "100%" } },
  },
];
